class Search {
  search: HTMLElement | null;
  searchButton: HTMLElement | null;
  header: HTMLElement | null;
  active: boolean = false;

  constructor() {
    this.search = document.querySelector(".search");
    this.searchButton = document.querySelector(".search__button");
    this.header = document.querySelector(".header");

    this.updateBehavior();

    window.addEventListener("resize", () => this.updateBehavior());
  }

  updateBehavior() {
    const hasAppointments = this.header?.classList.contains("header--appointments");
    const shouldBeActive = hasAppointments || window.innerWidth > 991.98;

    if (shouldBeActive && !this.active) {
      this.active = true;
      if (this.search && this.searchButton) {
        this.addEventListeners();
      }
    } else if (!shouldBeActive && this.active) {
      this.active = false;
      this.removeEventListeners();
      this.search?.classList.remove("search--active");
    }
  }

  addEventListeners() {
    this.searchButton?.addEventListener("click", this.handleToggle);
    document.addEventListener("click", this.handleOutsideClick);
    this.search?.addEventListener("focusout", this.handleFocusOut);
  }

  removeEventListeners() {
    this.searchButton?.removeEventListener("click", this.handleToggle);
    document.removeEventListener("click", this.handleOutsideClick);
    this.search?.removeEventListener("focusout", this.handleFocusOut);
  }

  handleToggle = (e: Event) => {
    e.stopPropagation();
    const isActive = this.search!.classList.toggle("search--active");
    if (isActive) {
      const input = this.search!.querySelector(
        ".search__input"
      ) as HTMLInputElement;
      input?.focus();
    }
  };

  handleOutsideClick = (e: MouseEvent) => {
    if (
      this.search!.classList.contains("search--active") &&
      !this.search!.contains(e.target as Node)
    ) {
      this.search!.classList.remove("search--active");
    }
  };

  handleFocusOut = (e: FocusEvent) => {
    const relatedTarget = e.relatedTarget as Node | null;
    if (!this.search!.contains(relatedTarget)) {
      this.search!.classList.remove("search--active");
    }
  };
}

export const search = new Search();
